import { LobbyWidget } from '@betty/moonlight';
import { memo } from 'react';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { useTranslation } from '@betty/i18n';

function ShopLobbyWidget() {
  const [t] = useTranslation('shop');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleClick = () => {
    navigation.navigate('Shop');
  };

  return (
    <LobbyWidget
      image="shop.lobbyWidgetIcon"
      label={t('widgetLabel')}
      onClick={handleClick}
    />
  );
}

export default memo(ShopLobbyWidget);
